import { useTranslation } from 'react-i18next';

export default function SubscriptionsSection() {
	const { t } = useTranslation('profile');

	return (
		<div className="profile-page__card">
			<h3>{t('subscriptions.title')}</h3>
			<div className="profile-page__plans">
				<article className="profile-page__plan is-current">
					<p className="profile-page__plan-title">{t('subscriptions.plans.proMonthly')}</p>
					<p className="profile-page__plan-meta">{t('subscriptions.meta.proMonthly')}</p>
				</article>
				<article className="profile-page__plan">
					<p className="profile-page__plan-title">{t('subscriptions.plans.enterpriseAnnual')}</p>
					<p className="profile-page__plan-meta">{t('subscriptions.meta.enterpriseAnnual')}</p>
				</article>
			</div>
		</div>
	);
}